import SidepanelFooter from './SidepanelFooter';

interface FilterActionsProps {
  onReset: () => void;
  onApply: () => void;
  onClose: () => void;
  hasActiveFilters: boolean;
}

export default function FilterActions({
  onReset,
  onApply,
  onClose,
  hasActiveFilters,
}: FilterActionsProps) {
  const handleResetFilters = () => {
    onReset();
    onClose();
  };

  const handleApplyFilters = () => {
    onApply();
    onClose();
  };

  return (
    <div className="border-t border-primary-70 w-full px-8 py-6 bg-white">
      <SidepanelFooter
        onResetFilters={handleResetFilters}
        onApplyFilters={handleApplyFilters}
        handleClose={onClose}
        canReset={hasActiveFilters}
      />
    </div>
  );
}
